import React, { useState } from "react";
import PropTypes from "prop-types";
import AmoModal from "components/AmoModal";
import BankingInformationForm from "components/BankingInformationForm";
import { bankInformationStatuses } from "constants/amoTableDropdownOptions";

/**
 * @param {object} props - object containing props for this component
 * @param {boolean} props.showModal - controls visibility of the modal
 * @param {Function} props.closeModal - function triggered when closing the modal
 * @param {Function} props.onApproveClick - function triggered when clicking Approve button
 * @param {Function} props.onRejectClick - function triggered when clicking Reject button
 * @param {object} props.formFields - object containing the information of the fields in this form
 * @param {object} props.bankingInformation - object containing the banking information data
 * @returns - the Review Banking Information modal, styled for the AMO project
 */
const BankingInformationDetailsModal = (props) => {
  const {
    showModal,
    closeModal,
    onApproveClick,
    onRejectClick,
    formFields,
    bankingInformation,
  } = props;

  const [shouldRefetchOnClose, setshouldRefetchOnClose] = useState(false);

  const disableActionButtons =
    bankingInformation.status !== bankInformationStatuses["Pending Review"];

  return (
    <AmoModal
      data-testid="bankingInformationDetailsModal"
      open={showModal}
      variant="default"
      title="Review Banking Information"
      width="50rem"
      showButton
      closePopover={() => closeModal(shouldRefetchOnClose)}
      buttonsLeftSpacer={4}
      buttons={[
        {
          key: "approve",
          label: "Approve",
          color: "primary",
          variant: "contained",
          width: "9rem",
          disabled: disableActionButtons,
          onClick: () => {
            onApproveClick(bankingInformation?.municipalityId);
            closeModal();
          },
        },
        {
          key: "reject",
          label: "Reject",
          color: "secondary",
          variant: "outlined",
          width: "9rem",
          disabled: disableActionButtons,
          onClick: () => {
            onRejectClick(
              bankingInformation?.municipalityId,
              bankingInformation?.fileId
            );
            closeModal();
          },
        },
        {
          key: "close",
          label: "Close",
          color: "primary",
          variant: "outlined",
          width: "9rem",
          onClick: () => {
            closeModal(shouldRefetchOnClose);
            setshouldRefetchOnClose(false);
          },
        },
      ]}
    >
      <br />
      <BankingInformationForm
        bankingInformation={bankingInformation}
        isModal
        formFields={formFields}
        onFileChange={() => setshouldRefetchOnClose(true)}
      />
    </AmoModal>
  );
};

BankingInformationDetailsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onApproveClick: PropTypes.func.isRequired,
  onRejectClick: PropTypes.func.isRequired,
  formFields: PropTypes.shape().isRequired,
  bankingInformation: PropTypes.shape().isRequired,
};

export default BankingInformationDetailsModal;
